import site from 'pro/config/site';
import { ContactAddress } from '@base/common/Contact';
import { useStoreState } from 'base/store';

export function CompanyInformation() {
    const { country } = useStoreState('rootStore');
    if (country === 'DE' || country === 'GB') {
        return (
            <>
                SINOWELL TRADING LIMITED
                <br/>
                Business Registration Number: 72609402
                <br/>
                RM 1006, 10/F PO YIP BLDG 23 HING YIP ST KWUN TONG KL
            </>
        )
    }

    return (
        <>
            {site.brand} Inc.
            <br/>
            <ContactAddress/>
        </>
    )
}